import { createFileRoute, redirect } from "@tanstack/react-router"
import "modules/auth/lang"

export const Route = createFileRoute("/_base/_public")({
  loader: ({ context, location }) => {
    const avoidRedirect = location.pathname.startsWith("/c/")

    if (context.auth.authStatus === "authenticated" && !avoidRedirect) {
      const redirectTo = new URLSearchParams(window.location.search).get("redirect")
      throw redirect({ to: redirectTo ?? "/insights" })
    }
  },
})
